/* Qatar Moms – visitor-side deferral.
   Same behaviour the old preload.js gave real shoppers; the Linux/PageSpeed
   detection and the "disable every script" branch are removed, so every
   visitor, Google and speed tests all get this identical page. */
(function () {
  var lazy_css = [];
  var lazy_js = [];
  var imageCount = 0;
  var lazyImages = 20;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (e) {
        if (e.nodeType !== 1) return;
        if (e.tagName === "IFRAME") {
          e.setAttribute("loading", "lazy");
          e.setAttribute("data-src", e.src);
          e.removeAttribute("src");
        }
        if (e.tagName === "IMG" && e.getAttribute("fetchpriority") === "high") { /* explicit LCP image (e.g. collection banner): never lazy, not counted */ } else if (e.tagName === "IMG" && ++imageCount > lazyImages) {
          e.setAttribute("loading", "lazy");
        }
        if (e.tagName === "LINK" && lazy_css.length) {
          lazy_css.forEach(function (t) {
            if (e.href.includes(t)) { e.setAttribute("data-href", e.href); e.removeAttribute("href"); }
          });
        }
        if (e.tagName === "SCRIPT") {
          if (lazy_js.length) {
            lazy_js.forEach(function (t) {
              if (e.src.includes(t)) { e.setAttribute("data-src", e.src); e.removeAttribute("src"); }
            });
          }
          if (e.innerHTML.includes("asyncLoad")) {
            e.innerHTML = e.innerHTML
              .replace("if(window.attachEvent)", "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)")
              .replaceAll(", asyncLoad", ", function(){}");
          }
          if (e.innerHTML.includes("PreviewBarInjector") || e.innerHTML.includes("adminBarInjector")) {
            e.innerHTML = e.innerHTML.replace("DOMContentLoaded", "loadBarInjector");
          }
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
